import script from "./ShowLessonView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowLessonView.vue?vue&type=script&setup=true&lang=ts"

import "./ShowLessonView.vue?vue&type=style&index=0&id=0c0fba19&lang=scss"

const __exports__ = script;

export default __exports__